/**
 * Shared DOM injection helpers used by `ThemeFontSource.load()`
 * implementations. Kept generic (no brand knowledge) so brand definitions
 * only provide *what* to load, not *how*.
 */

/** Injects a `<link rel="stylesheet">` into the parent document once. */
export const loadStylesheetLink = (href: string): void => {
  if (typeof document === "undefined") return
  if (document.querySelector(`link[href="${href}"]`)) return

  const link = document.createElement("link")
  link.rel = "stylesheet"
  link.href = href
  document.head.appendChild(link)
}

/** Injects an inline `<style>` block into the parent document once. */
export const loadInlineStyle = (id: string, css: string): void => {
  if (typeof document === "undefined") return
  if (document.getElementById(id)) return

  const style = document.createElement("style")
  style.id = id
  style.textContent = css
  document.head.appendChild(style)
}
